import * as Yup from 'yup';

const validationSchema = () => {
  return Yup.object({
    description: Yup.string().max(1000, 'tracker.describeFood.description.limitReached'),
  });
};

export default validationSchema;
